import { render, staticRenderFns } from "./ObjectiveTopic.vue?vue&type=template&id=6062562e"
import script from "./ObjectiveTopic.vue?vue&type=script&lang=js"
export * from "./ObjectiveTopic.vue?vue&type=script&lang=js"
import style0 from "./ObjectiveTopic.vue?vue&type=style&index=0&id=6062562e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports